import React from 'react';
import { generateBem, combineClassNames } from 'lib/utility';

const CardEditFieldBtn = ({ text, aria_label, title, onClick, data_testid, modifiers = [] }) => (
  <button
    className={combineClassNames(generateBem('card__edit_field_btn', modifiers), 'table-btn left-btn')}
    type="button"
    aria-label={aria_label}
    title={title}
    onClick={onClick}
    data-testid={data_testid}
  >
    {modifiers.includes('destructive') ? (
      <span className="fa fa-trash" />
    ) : (
      <span className="fa fa-edit" />
    )}
    {` ${text}`}
  </button>
);

export default CardEditFieldBtn;
